import React from "react"
import "./ErrorBoundary.css"


export default class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props)
        this.state = {error: null, copied: false}
    }

    static getDerivedStateFromError(error) {
        return {error}
    }

    copyError = () => {
        const error = this.state.error
        navigator.clipboard.writeText('Path: ' + window.location.pathname + '\n' + error.message + '\n' + error.stack)
        this.setState({copied: true})
        setTimeout(() => this.setState({copied: false}), 2000)
    }

    render() {
        if (this.state.error) {
            const error = this.state.error
            return <div id="error-boundary">
                <h1>Greška u aplikaciji</h1>
                
                <p>
                    Došlo je do neočekivane greške.
                    Molimo vas da snimite ekran (screenshot), ili još bolje kliknete na dugme "Kopiraj grešku"
                    i onda je pošaljete Lovri na WhatsApp.
                </p>
                
                <div className="buttons">
                    <button className="btn btn-secondary btn-sm" onClick={this.copyError}><i className="fa-regular fa-copy"/> {this.state.copied ? 'Kopirano!' : 'Kopiraj grešku'}</button>
                    <a className="btn btn-whatsapp btn-sm" href="https://api.whatsapp.com/send?phone=381638202444"><i className="fa-brands fa-whatsapp"/> Pošalji</a>
                </div>

                <pre>Path: {window.location.pathname}{'\n'}{error.message}{'\n'}{error.stack}</pre>

                <button className="btn btn-primary" onClick={() => window.location.reload()}>Osveži stranicu</button>
            </div>
        }
        return this.props.children
    }
}
